// import { motion } from "framer-motion";
// import React from "react";
// import ShowCase1 from "../../imgs/DrAdem.png";
// import ShowCase3 from "../../imgs/foxnox.png";
// import ShowCase4 from "../../imgs/w4.png";
// import ShowCase5 from "../../imgs/w5.png";
// import ShowCase2 from "../../imgs/zahrapay.png";
// import { fadeIn, staggerChildren } from "../../utils/motion";
// import css from "./Portfolio.module.scss";

// const Portfolio = () => {
//   return (
//     <motion.section
//       variants={staggerChildren}
//       initial="hidden"
//       whileInView="show"
//       viewport={{ once: false, amount: 0.25 }}
//       className={`paddings ${css.wrapper}`}
//     >
//       <a className="anchor" id="projects"></a>

//       <div className={`flexCenter innerWidth ${css.container}`}>
//         <div className={`flexCenter ${css.heading}`}>
//           <div>
//             <span className="primaryText">My Latest Works</span>
//             <p style={{ marginTop: "15px" }}>
//               Here checkout my projects I've completed recently.
//             </p>
//           </div>

//           {/* <a
//             href="https://github.com/ibrahimafzal?tab=repositories"
//             target="_blank"
//             rel=" noreferrer"
//             title="Visit My GitHub Repository"
//           >
//             <span className="secondaryText">Explore More Works</span>
//           </a> */}
//         </div>

//         {/* images */}
//         <div className={`flexCenter ${css.showCase}`}>
//           <a
//             href="https://web.uat.dr-adem.com/"
//             target="_blank"
//             rel="noreferrer noopener"
//           >
//             <motion.img
//               variants={fadeIn("up", "tween", 0.5, 0.6)}
//               src={ShowCase1}
//               alt="ACE-Academy"
//               style={{ width: "100%", borderRadius: "20px", height: "20rem" }}
//             />
//           </a>
//           <a
//             href="https://zahrapay.com/"
//             target="_blank"
//             rel="noreferrer noopener"
//           >
//             <motion.img
//               variants={fadeIn("up", "tween", 0.7, 0.6)}
//               src={ShowCase2}
//               alt="AgilityUp"
//               style={{ width: "100%", borderRadius: "20px", height: "20rem" }}
//             />
//           </a>
//           <a
//             href="https://foxnoxsocial.com/"
//             target="_blank"
//             rel="noreferrer noopener"
//           >
//             <motion.img
//               variants={fadeIn("up", "tween", 0.9, 0.6)}
//               src={ShowCase3}
//               alt="Fri-Chicks"
//               style={{ width: "100%", borderRadius: "20px", height: "20rem" }}
//             />
//           </a>
//           <a
//             href="https://selecktstaff.com/"
//             target="_blank"
//             rel="noreferrer noopener"
//           >
//             <motion.img
//               variants={fadeIn("up", "tween", 0.9, 0.6)}
//               src={ShowCase4}
//               alt="Numylo"
//               style={{ width: "100%", borderRadius: "20px", height: "20rem" }}
//             />
//           </a>

//           <a
//             href="https://www.numylo.com/"
//             target="_blank"
//             rel="noreferrer noopener"
//           >
//             <motion.img
//               variants={fadeIn("up", "tween", 0.9, 0.6)}
//               src={ShowCase5}
//               alt=""
//               style={{ width: "100%", borderRadius: "20px", height: "20rem" }}
//             />
//           </a>
//         </div>
//       </div>
//     </motion.section>
//   );
// };

// export default Portfolio;

import { motion } from "framer-motion";
import ShowCase1 from "../../imgs/DrAdem.png";
import ShowCase3 from "../../imgs/foxnox.png";
import ShowCase4 from "../../imgs/w4.png";
import ShowCase5 from "../../imgs/w5.png";
import ShowCase2 from "../../imgs/zahrapay.png";
import { fadeIn, staggerChildren } from "../../utils/motion";
import css from "./Portfolio.module.scss";

// Project data with details
const projects = [
  {
    id: 1,
    title: "Dr Adem — Oncology Patient Management",
    description:
      "Built a healthcare app with role-based dashboards, lab result analysis, chat, media uploads, OTP login, Firebase notifications, and medicine scheduling for doctors and patients",
    technologies: ["React", "Redux", "FCM", "Tailwind CSS", "ShadCN UI"],
    image: ShowCase1,
    link: "https://web.uat.dr-adem.com/",
    category: "Healthcare",
  },
  {
    id: 2,
    title: "ZahraPay",
    description:
      "Developed ZahraPay, a secure payment platform enabling seamless USD/ZAR transfers with encryption, scalable APIs, fast transactions, and a user-friendly, responsive interface.",
    technologies: ["React", "Redux", "Tailwind CSS"],
    image: ShowCase2,
    link: "https://zahrapay.com/",
    category: "Cross-Currency Payment Gateway",
  },
  {
    id: 3,
    title: "Fox Nox",
    description:
      "Built FoxNox backend with real-time chat, friend requests, Stripe payments, FCM notifications, and dynamic promotions—connecting students to events, groups, and nightlife experiences.",
    technologies: ["Node.js", "Socket.io", "FCM", "MongoDB", "Express.js"],
    image: ShowCase3,
    link: "https://foxnoxsocial.com/",
    category: "Campus Nightlife & Social Events Platform",
  },
  {
    id: 4,
    title: "SelectkStaff",
    description:
      "Built a smart recruitment platform with real-time chat, admin panel, notifications, and seamless job matching using React, Node.js, MongoDB, Tailwind, and Redux.",
    technologies: [
      "React.js",
      "Tailwind CSS",
      "Redux",
      "Node.js",
      "MongoDB",
      "Express.js",
      "FCM",
      "Socket.io",
    ],
    image: ShowCase4,
    link: "https://selecktstaff.com/",
    category: "Recruitment & Job Placement Platform",
  },
  {
    id: 5,
    title: "Numylo Solutions",
    description:
      "Developed a centralized platform offering tool access, intelligent integrations, secure single sign-on, enhanced communication, integrated video meetings, and a fully customizable user interface.",
    technologies: [
      "React",
      "Redux",
      "Bootstrap",
      "Node.js",
      "Express.js",
      "Zoom APIs",
      "Calendly APIs",
      "Currency Exchange APIs",
      "MongoDB",
    ],
    image: ShowCase5,
    link: "https://www.numylo.com/",
    category: "Unified Workspace Platform",
  },
];

const Portfolio = () => {
  return (
    <motion.section
      variants={staggerChildren}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
      className={`paddings ${css.wrapper}`}
    >
      <a className="anchor" id="projects"></a>

      <div className={`flexCenter innerWidth ${css.container}`}>
        <div className={`flexCenter ${css.heading}`}>
          <div>
            <span className="primaryText">My Latest Works</span>
            <p style={{ marginTop: "15px" }}>
              Here checkout my projects I've completed recently.
            </p>
          </div>
        </div>

        {/* Enhanced project showcase */}
        <div className={`flexCenter ${css.showCase}`}>
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              variants={fadeIn("up", "tween", 0.5 + index * 0.2, 0.6)}
              className={css.projectCard}
              whileHover="hover"
              initial="initial"
            >
              <a
                href={project.link}
                target="_blank"
                rel="noreferrer noopener"
                className={css.projectLink}
              >
                <div className={css.imageContainer}>
                  <img
                    src={project.image || "/placeholder.svg"}
                    alt={project.title}
                    className={css.projectImage}
                  />

                  {/* Hover overlay with sliding text */}
                  <motion.div
                    className={css.overlay}
                    variants={{
                      initial: { opacity: 0 },
                      hover: { opacity: 1 },
                    }}
                    transition={{ duration: 0.3 }}
                  >
                    <motion.div
                      className={css.projectDetails}
                      variants={{
                        initial: { y: 100, opacity: 0 },
                        hover: { y: 0, opacity: 1 },
                      }}
                      transition={{
                        duration: 0.4,
                        ease: [0.25, 0.46, 0.45, 0.94],
                      }}
                    >
                      <div className={css.category}>{project.category}</div>
                      <h3 className={css.projectTitle}>{project.title}</h3>
                      <p className={css.projectDescription}>
                        {project.description}
                      </p>
                      <div className={css.technologies}>
                        {project.technologies.map((tech, techIndex) => (
                          <span key={techIndex} className={css.tech}>
                            {tech}
                          </span>
                        ))}
                      </div>
                      <div className={css.viewProject}>
                        <span>View Project</span>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M7 17L17 7M17 7H7M17 7V17" />
                        </svg>
                      </div>
                    </motion.div>
                  </motion.div>
                </div>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Portfolio;
